// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  position: relative;
}

@keyframes gradient-shift {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

/* 页面切换动画 */
.page-transition-enter {
  opacity: 0;
  transform: translateX(100px);
}

.page-transition-enter-active {
  opacity: 1;
  transform: translateX(0);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.page-transition-exit {
  opacity: 1;
  transform: translateX(0);
}

.page-transition-exit-active {
  opacity: 0;
  transform: translateX(-100px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

/* 通用按钮样式 */
.romantic-button {
  background: linear-gradient(45deg, #ff69b4, #ff1493);
  border: none;
  color: white;
  padding: 12px 30px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 105, 180, 0.4);
  text-decoration: none;
  display: inline-block;
  text-align: center;
}

.romantic-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 105, 180, 0.6);
  background: linear-gradient(45deg, #ff1493, #dc143c);
}

.romantic-button:active {
  transform: translateY(0);
}

/* 卡片样式 */
.romantic-card {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 30px;
  margin: 20px;
  box-shadow: 0 8px 32px rgba(255, 105, 180, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.romantic-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 40px rgba(255, 105, 180, 0.3);
}

/* 标题样式 */
.romantic-title {
  background: linear-gradient(45deg, #ff69b4, #ff1493);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 2.5rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 30px;
  text-shadow: 0 2px 4px rgba(255, 105, 180, 0.3);
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,MAAM,6BAA6B,EAAE;EACrC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,WAAW;AACX;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,kDAAkD;AACpD;;AAEA,WAAW;AACX;EACE,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;EAC/C,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,SAAS;AACT;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,+CAA+C;EAC/C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,SAAS;AACT;EACE,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;AACjD","sourcesContent":[".App {\n  min-height: 100vh;\n  position: relative;\n}\n\n@keyframes gradient-shift {\n  0% { background-position: 0% 50%; }\n  50% { background-position: 100% 50%; }\n  100% { background-position: 0% 50%; }\n}\n\n/* 页面切换动画 */\n.page-transition-enter {\n  opacity: 0;\n  transform: translateX(100px);\n}\n\n.page-transition-enter-active {\n  opacity: 1;\n  transform: translateX(0);\n  transition: opacity 0.5s ease, transform 0.5s ease;\n}\n\n.page-transition-exit {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.page-transition-exit-active {\n  opacity: 0;\n  transform: translateX(-100px);\n  transition: opacity 0.5s ease, transform 0.5s ease;\n}\n\n/* 通用按钮样式 */\n.romantic-button {\n  background: linear-gradient(45deg, #ff69b4, #ff1493);\n  border: none;\n  color: white;\n  padding: 12px 30px;\n  border-radius: 25px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(255, 105, 180, 0.4);\n  text-decoration: none;\n  display: inline-block;\n  text-align: center;\n}\n\n.romantic-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(255, 105, 180, 0.6);\n  background: linear-gradient(45deg, #ff1493, #dc143c);\n}\n\n.romantic-button:active {\n  transform: translateY(0);\n}\n\n/* 卡片样式 */\n.romantic-card {\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 30px;\n  margin: 20px;\n  box-shadow: 0 8px 32px rgba(255, 105, 180, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n}\n\n.romantic-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 12px 40px rgba(255, 105, 180, 0.3);\n}\n\n/* 标题样式 */\n.romantic-title {\n  background: linear-gradient(45deg, #ff69b4, #ff1493);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-size: 2.5rem;\n  font-weight: 700;\n  text-align: center;\n  margin-bottom: 30px;\n  text-shadow: 0 2px 4px rgba(255, 105, 180, 0.3);\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
